// neo_cogym — 좌석 관리 클라이언트 (W9, 학교 관리자)
import { apiFetch } from "./client";

export interface SeatPool {
  id: string;
  seats_total: number;
  seats_used: number;
  valid_until: string | null;
  product_title: string;
  course_id: string;
}

export function getSeatPools(): Promise<{ pools: SeatPool[] }> {
  return apiFetch("/api/seats/pools");
}

export interface SeatAssignment {
  id: string;
  assigned_at: string;
  email: string | null;
  display_name: string | null;
}

/** 학생 식별자(이메일 또는 user-id uuid)로 좌석 배정. '@' 포함 시 이메일로 전송. */
export function assignSeat(
  poolId: string,
  identifier: string,
): Promise<{ ok: boolean; assignmentId: string }> {
  const body = identifier.includes("@")
    ? { poolId, email: identifier.trim() }
    : { poolId, userId: identifier.trim() };
  return apiFetch("/api/seats/assign", { method: "POST", body: JSON.stringify(body) });
}

export function getSeatAssignments(poolId: string): Promise<{ assignments: SeatAssignment[] }> {
  return apiFetch(`/api/seats/assignments?poolId=${encodeURIComponent(poolId)}`);
}

export function releaseSeat(assignmentId: string): Promise<{ ok: boolean }> {
  return apiFetch("/api/seats/release", { method: "POST", body: JSON.stringify({ assignmentId }) });
}
